/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { LeadingSourcesTable } from "./LeadingSourcesTable";
import { useLeadingSources } from "../../store/useLeadingSources";

function LeadingSources() {
  /** Hooks */
  const navigate = useNavigate();
  const { leadingSources, getLeadingSources } = useLeadingSources();

  /** Effects */
  useEffect(() => {
    getLeadingSources();
  }, []);

  /** Callbacks */
  const addLeadingSource = () => navigate(`/add-leading-source`);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Leading Sources
        </h1>
        <PrimaryButton
          label="Add new"
          onClick={addLeadingSource}
          className="h-10 !bg-droppie-oranje !border-droppie-oranje active:!bg-droppie-oranje-dark"
          size="sm"
        />
      </div>
      <div className="w-full px-7 py-7 bg-white  border-gray-border drop-shadow-none rounded-xl">
        {!leadingSources?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Leading Source created yet.
          </p>
        ) : (
          <LeadingSourcesTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(LeadingSources);
